// extracted by mini-css-extract-plugin
export default {"UserMgtBottomContainer":"usermgtbottomcontainer_UserMgtBottomContainer__kBOCK"};